import Vue from 'vue';
import Vuex from 'vuex';
import getters from '@/store/getters.js';
import actions from '@/store/actions.js';
import mutations from '@/store/mutations.js';
import state from '@/store/state.js';

Vue.use(Vuex);
const store = new Vuex.Store({
  state,
  getters,
  actions, // actions通常跟api接口打交道
  mutations
});

export default store;
